<template>
    <modal id="work-place-translate-modal"
           size="large"
           v-model="showModal"
           :title="$t('translate')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='`${TENANT_BASE_URL}app/work-place/${workPlaceId}/translate`'
            @submit.prevent="submitData"
        >
            <app-form-group
                :label="$t('from_language')"
                type="select"
                v-model="formData.from"
                :list="languages"
                :required="true"
            />
            <app-form-group
                :label="$t('to_language')"
                type="multi-select"
                v-model="formData.to"
                :list="languages.filter(lang => lang.key !== formData.from)"
                :required="true"
                :disable-search="true"
            />
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {mapState} from "vuex";

export default {
    name: "WorkPlaceTranslate",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        workPlaceId: {
            required: true
        }
    },
    data() {
        return {
            TENANT_BASE_URL,
            formData: {
                from: localStorage.getItem('app-language') || 'ja',
                to: [],
            },
        }
    },
    computed: {
        ...mapState({
            languages: state => state.support.languages
        }),
    },
    methods: {
        submitData() {
            this.loading = true;
            const formData = this.formData;
            this.submitFromFixin('post', this.$refs.form.dataset["url"], formData);
        },
        afterSuccess({data}) {
            this.loading = false;
            $('#work-place-translate-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'work-place-table');
        },
    },
}
</script>

<style scoped>
::v-deep .chips-container {
    min-height: 150px !important;
}
</style>